import React from "react"

import { Helmet } from "react-helmet"

interface INedvizhimosti {
  url?: string
  shortTitle?: string
  description?: string
  titleH1?: string
}

export const Nedvizhimosti = ({
  url,
  shortTitle,
  description,
  titleH1,
}: INedvizhimosti) => (
  <Helmet>
    <script type="application/ld+json">
      {JSON.stringify([
        {
          "@context": "https://schema.org",
          "@type": "BankOrCreditUnion",

          name: "Совкомбанк",
          image: "https://sovcombank.ru/logo.png",
          "@id": "https://sovcombank.ru",
          url: "https://sovcombank.ru/",
          telephone: "8 (800) 700-66-96",
          priceRange: "50 000 - 30 000 000",
          address: {
            "@type": "PostalAddress",
            streetAddress: "Краснопресненская набережная, 14 стр 1",
            addressLocality: "Москва",
            postalCode: "123100",
            addressCountry: "RU",
          },
          openingHoursSpecification: {
            "@type": "OpeningHoursSpecification",
            dayOfWeek: [
              "Monday",
              "Tuesday",
              "Wednesday",
              "Thursday",
              "Friday",
              "Saturday",
              "Sunday",
            ],
            opens: "00:00",
            closes: "23:59",
          },
          sameAs: [
            "https://ru.wikipedia.org/wiki/Совкомбанк",
            "https://sovcombank.ru",
            "https://www.youtube.com/channel/UCptG0e45r5jZexlXJ_obmvA",
          ],
        },
        {
          "@context": "https://schema.org/",
          "@type": "BreadcrumbList",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: "Главная",
              item: "https://sovcombank.ru/",
            },
            {
              "@type": "ListItem",
              position: 2,
              name: "💰 Кредиты",
              item: "https://sovcombank.ru/credits",
            },
            {
              "@type": "ListItem",
              position: 3,
              name: "💵 Кредиты под залог",
              item: "https://sovcombank.ru/credits/pod-zalog",
            },
            {
              "@type": "ListItem",
              position: 4,
              name: `${shortTitle}`,
              item: `${url}`,
            },
          ],
        },
        {
          "@context": "https://schema.org/",
          "@type": "Product",
          name: `${titleH1}`,
          image: "https://sovcombank.ru/logo.png",
          description: `${description}`,
          brand: {
            "@type": "Brand",
            name: "Совкомбанк",
          },
          offers: {
            "@type": "AggregateOffer",
            url: `${url}`,
            priceCurrency: "RUB",
            lowPrice: "200000",
            highPrice: "30000000",
          },
          aggregateRating: {
            "@type": "AggregateRating",
            ratingValue: "4,9",
            bestRating: "5",
            worstRating: "1",
            ratingCount: "10634",
          },
        },
      ])}
    </script>
    <script type="application/ld+json">
      {JSON.stringify([
        {
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: [
            {
              "@type": "Question",
              name: "Как оформляется кредит под залог? ",
              acceptedAnswer: {
                "@type": "Answer",
                text: "Заполните короткую анкету, указав ФИО и номер для связи.Дождитесь звонка менеджера банка и получите предварительное решение.Подготовьте пакет документов.Подпишите договор, кредитно-обеспечительную документацию и документы по страхованию.Оформите залог на недвижимость в Росреестре. При желании банк может это сделать без вашего участия.Получите деньги одним из доступных способов.",
              },
            },
            {
              "@type": "Question",
              name: "Можно ли получить деньги под залог без официального трудоустройства?",
              acceptedAnswer: {
                "@type": "Answer",
                text: "Сумму до 1 000 000 рублей можно получить без официального трудоустройства. Каждый случай банк рассматривает в индивидуальном порядке. Оставьте заявку, чтобы получить быстрое решение.",
              },
            },
            {
              "@type": "Question",
              name: "Каким образом ставится залог на недвижимость?",
              acceptedAnswer: {
                "@type": "Answer",
                text: "После подписания договора на недвижимость накладывают обременение в Росреестре. Банк самостоятельно подает документы в ЕГРН в электронном виде.В течение пяти дней залог зарегистрируют, и вы сможете получить свои средства.",
              },
            },
            {
              "@type": "Question",
              name: "Сколько по времени занимает процедура оформления залогового кредита?",
              acceptedAnswer: {
                "@type": "Answer",
                text: "Как правило — до 9 рабочих дней (столько времени занимает регистрация залога в Росреестре), но в определенных законом случаях срок может быть сокращен или продлен. Если вы воспользуетесь услугой «Электронная регистрация», то сроки регистрации сократятся.",
              },
            },
            {
              "@type": "Question",
              name: "Можно ли дистанционно получить кредит под залог?",
              acceptedAnswer: {
                "@type": "Answer",
                text: "Да, всю процедуру можно пройти дистанционно. В этом случае обмен документами происходит в электронном виде по официальным каналам банка.",
              },
            },
            {
              "@type": "Question",
              name: "Смогу ли я продать залоговую квартиру?",
              acceptedAnswer: {
                "@type": "Answer",
                text: "В залоговой недвижимости можно проживать, прописывать родственников и сдавать в аренду. Продать ее до полного погашения задолженности не получится.Однако покупатель может погасить кредит вместо заемщика в счет оплаты квартиры или дома. Тогда обременение снимут и можно будет беспрепятственно оформлять договор купли-продажи.",
              },
            },
          ],
        },
      ])}
    </script>
  </Helmet>
)
